export default {
  state: {
    educationalLevel: null,
    regions: [],
    allDocumentSpecs: {},
  },
};
